import React, { useEffect } from "react";
import { claimService } from "../../../../api/services/claimService";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsValue {
  setAllActions: (data: any) => void;
}
const DTOTransferARModal = ({ setAllActions }: PropsValue) => {
  const stored_actions = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredActions
  );

  useEffect(() => {
    if (stored_actions) setAllActions(stored_actions);
  }, []);
  return <></>;
};

export default DTOTransferARModal;
